import {createReducer} from '../utility'




export const hasPaid = createReducer({},{
    "PAYMENT_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                message: data
            }
        }else{
            return{
                ...state
            }
        }
    }
})


export const paymentStatus = createReducer({},{
    "PAYMENT_STATUS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    }
})


export const generatedBillId = createReducer({},{
    "GENERATE_BILL_ID_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                billId: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_PAYMENTS"(state, {data}){
        return{
            ...state,
            billId: null
        }
    }
})